import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SecurityIcon from "@mui/icons-material/Security";
import axios from "axios";
import { useSelector } from "react-redux";
import ResetRuPayPinDialog from "./ResetRuPayPinDialog";
import { baseapi } from "../Environmentalurl";
import { ApplicationType, date, entity_id, getGeolocation, location, locationGeo, Platform } from "../Utils/Const";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function ForgotRuPayPinDialog({ open, onClose }) {
  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);

  const mobile = sessionStorage.getItem("mobileNumber");
  const sessionId = sessionStorage.getItem("SessionID");
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [maskedCard, setMaskedCard] = useState("");
  const [openReset, setOpenReset] = useState(false);
  const [answer, setAnswer] = useState("");
 const ip = useIPAddress();
  /* =========================
     CALL API WHEN DIALOG OPENS
  ========================== */
  const fetchSecurityQuestions = async () => {
    if (!rupayRefNo) {
      console.warn("Missing rupayRefNo");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
        Mobilenumber: mobile,
        ReferenceNumber: rupayRefNo,
        Platform: Platform,
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: sessionId,
      };

      const res = await api.post(
        `${baseapi}/getcardstatus`,
        payload
      );

      if (res.data.Response_Code === "4001") {
        const q = [
          res.data.Security_Question,
          res.data.Security_Question_2,
          res.data.Security_Question_3,
        ].filter(Boolean);

        setQuestions(q);
        setMaskedCard(res.data.MaskedCard);
      }
    } catch (err) {
      console.error("API failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifySecurity = async () => {
    try {
      setLoading(true);

      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_RuPayVerifySecurity",
        Mobilenumber: mobile,
        SecurityQuestion: selectedQuestion,
        SecurityAnswer: answer,
        ReferenceNumber: rupayRefNo,
        SessionID: sessionId,
        CardNumber: maskedCard,
        Date: date,
        Platform: Platform,
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const res = await api.post(
        `${baseapi}/ruPayVerifySecurity`,
        payload
      );

      if (res.data.Response_Code === "1000") {
        // ✅ SUCCESS → OPEN RESET PIN UI
        setOpenReset(true);
      } else {
        alert(res.data.Message || "Verification failed");
      }
    } catch (err) {
      console.error(err);
      alert("Verification failed");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (open) {
      setAnswer("");
      setSelectedQuestion(null);
      setQuestions([]);
    }
  }, [open]);

  return (
    <>
      <Box
        sx={{
          display: open ? "flex" : "none",
          position: "fixed",
          inset: 0,
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(0,0,0,0.45)",
          zIndex: 2000,
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <Box
          sx={{
            width: 380,
            bgcolor: "#fff",
            borderRadius: 4,
            boxShadow: "0px 20px 50px rgba(0,0,0,0.25)",
            p: 3,
          }}
        >
          {/* HEADER */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <IconButton onClick={onClose}>
              <ArrowBackIcon />
            </IconButton>

            <Typography fontSize={16} fontWeight={700}>
              Forgot RuPay PIN
            </Typography>

            <IconButton>
              <HelpOutlineIcon sx={{ color: "#22c55e" }} />
            </IconButton>
          </Box>

          {/* CONTENT */}
          <Box mt={3} textAlign="center">
            <Typography fontSize={16} fontWeight={700} mb={0.5}>
              Security Verification
            </Typography>

            <Typography fontSize={13} color="text.secondary">
              Please answer your registered security question to proceed.
            </Typography>
          </Box>

          {/* SECURITY QUESTION */}
          <Box mt={3}>
            <Typography fontSize={13} mb={0.5}>
              Security Question
            </Typography>

            <Select
              fullWidth
              value={selectedQuestion}
              onChange={(e) => {
                setSelectedQuestion(e.target.value);
                setAnswer("");
              }}
              onOpen={() => {
                if (questions.length === 0) {
                  fetchSecurityQuestions();
                }
              }}
              displayEmpty
              MenuProps={{
                disablePortal: true,
                PaperProps: {

                  
                  sx: { zIndex: 3000, mt: 1 },
                },
              }}
              renderValue={(value) =>
                value ? value : <em>Select security question</em>
              }
            >
              {questions.map((q, i) => (
                <MenuItem key={i} value={q}>
                  {q}
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* ANSWER */}
          <Box mt={2}>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13}>Answer</Typography>
              <Typography fontSize={12} color="text.secondary">
                {answer.length}/25
              </Typography>
            </Box>

            <TextField
              fullWidth
              disabled={!selectedQuestion}
              value={answer}
              onChange={(e) => setAnswer(e.target.value.slice(0, 25))}
              placeholder="Enter your answer"
            />
          </Box>

          {/* INFO */}
          <Box
            mt={2}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              backgroundColor: "#f8fafc",
              borderRadius: 2,
              p: 1,
            }}
          >
            <SecurityIcon sx={{ fontSize: 16, color: "#6b7280" }} />
            <Typography fontSize={12} color="#6b7280">
              Your information remains private and encrypted.
            </Typography>
          </Box>

          {/* SUBMIT */}
          <Button
            fullWidth
            disabled={!selectedQuestion || !answer || loading}
            onClick={handleVerifySecurity}
            sx={{
              mt: 3,
              height: 46,
              borderRadius: 2,
              backgroundColor: "#059669",
              color: "white",
              "&:hover": { backgroundColor: "#047857" },
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Verify & Continue
          </Button>

          {/* FOOTER */}
          <Typography
            mt={2}
            textAlign="center"
            fontSize={13}
            sx={{ color: "#22c55e", cursor: "pointer", fontWeight: 500 }}
          >
            Try other verification options
          </Typography>
        </Box>
      </Box>
      <ResetRuPayPinDialog
        open={openReset}
        onClose={() => {
          setOpenReset(false);
          onClose();
        }}
      />
    </>
  );
}
